import type { PureQueryOptions } from '@apollo/client';
import { gql } from '~/apollo/client-v3';
import { useQuery } from '@apollo/client';
import * as fragments from '~/apollo/fragments';
import type {
  StudyProductionRouteQuery,
  StudyProductionRouteQueryVariables,
} from '~/apollo/generated/v3/graphql';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SupportingObjectList } from '~/components/supportingObject/SupportingObjectList';
import { useStudyOutletContext } from '~/routes/study/$studyId';

const STUDY_PRODUCTION_ROUTE = gql`
  query StudyProductionRoute($studyId: Int!) {
    studyList(id: $studyId) {
      ...studyParts
      production {
        ...productionParts
        pictures {
          ...pictureParts
          file {
            ...fileParts
          }
        }
        files {
          ...fileParts
        }
      }
    }
  }

  ${fragments.studyParts}
  ${fragments.productionParts}
  ${fragments.pictureParts}
  ${fragments.fileParts}
`;

export default function StudyProductionRoute() {
  const ctx = useStudyOutletContext();
  const studyId = ctx.study.id;

  const { data, loading } = useQuery<
    StudyProductionRouteQuery,
    StudyProductionRouteQueryVariables
  >(STUDY_PRODUCTION_ROUTE, { variables: { studyId } });

  const refetchQueries: PureQueryOptions[] = [
    { query: STUDY_PRODUCTION_ROUTE, variables: { studyId } },
  ];

  const productions =
    data?.studyList.find(s => s.id === studyId)?.production ?? [];

  if (loading) return <SpinnerPlaceholder />;
  return (
    <SupportingObjectList
      items={productions}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.Production}
      refetchQueries={refetchQueries}
    />
  );
}
